export default __webpack_public_path__ + "static/media/icon_other_BridalSet.ad6922b8.png";